import i18next  from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector';

import translation_en_us from './resources/en-us'
import translation_es from './resources/es-es'
import translation_sr_latn from './resources/sr-latn'
import translation_sr_cyrl from './resources/sr-cyrl';
import translation_fr_fr from './resources/fr-fr';
import translation_de_de from './resources/de-de';
import translation_it from './resources/it-it'
import translation_pl from './resources/pl-pl'

export interface IResource {
    header_title: string;
    header_title_short: string;
    header_menu_api: string;
    header_signup_text: string;
    header_signin_text: string;
    header_dashboard_text: string;

    general_title_text: string;
    general_cta_text_all: string;
    general_cta_text_one: string;
    general_cta_text_two: string;
    general_cta_text_three: string;
    general_cta_button: string;
    general_cta_contact: string;
    general_cta_button_quick: string;
    general_tos_text: string;
    general_tos_tooltip: string;
    general_privacy_text: string;
    general_privacy_tooltip: string;
    general_cookies_text: string;
    general_cookies_tooltip: string;
    general_refund_text: string;
    general_refund_tooltip: string;
    general_cta_consent_one: string;
    general_cta_consent_two: string;

    usecase_title_head: string;
    usecase_title_subhead: string;

    usecase_interviewer_title: string;
    usecase_interviewer_subtitle: string;
    usecase_interviewer_body: string;
    usecase_interviewer_learnmore: string;
    usecase_interviewer_imgalt: string;
    
    usecase_collaboration_title: string;
    usecase_collaboration_subtitle: string;
    usecase_collaboration_body_one: string;
    usecase_collaboration_body_two: string;
    usecase_collaboration_learnmore: string;
    usecase_collaboration_imgalt: string;

    usecase_recruiter_title: string;
    usecase_recruiter_subtitle: string;
    usecase_recruiter_body: string;
    usecase_recruiter_learnmore: string;
    usecase_recruiter_imgalt: string;

    usecase_call_title: string;
    usecase_call_subtitle: string;
    usecase_call_body_one: string;
    usecase_call_body_two: string;
    usecase_call_learnmore: string;
    usecase_call_imgalt: string;

    footer_email_text: string;

    signout_menu_text: string;
    me_menu_text: string;
    
    help_menu_text: string;

    // No sign-up or download required.
    cta_nosignup_text: string;

    // Language
    language_selector_title: string;
    // English
    language_en_title: string;
    // Spanish
    language_es_title: string;
    // Srpski
    language_srLatn_title: string;
    // Српски
    language_srCyrl_title: string;
    // Français
    language_fr_title: string;
    // Deutsche
    language_de_title:string;
    // Italian
    language_it_title:string;
    // Polski
    language_pl_title: string;
}

i18next
    .use(LanguageDetector)
    .init({
        debug: false,

        interpolation: {
            // React already does escaping
            escapeValue: false,
        },

        resources: {
            'en': {
                translation: translation_en_us
            },
            'en-US': {
                translation: translation_en_us
            },
            'es': {
                translation: translation_es
            },
            'fr': {
                translation: translation_fr_fr,
            },
            'de': {
                translation: translation_de_de,
            },
            'it': {
                translation: translation_it,
            },
            'pl': {
                translation: translation_pl,
            },            
            'sr-Latn': {
                translation: translation_sr_latn
            },
            'sr-Cyrl': {
                translation: translation_sr_cyrl
            },
            'sr': {
                translation: translation_sr_cyrl
            },
        },

        nonExplicitWhitelist: true,
        fallbackLng: 'en',
        detection: {
            caches: ['localStorage', 'cookie'],
            lookupLocalStorage: 'meet-i18n',
            lookupCookie: 'meet-i18n'
        }
    })


export default i18next;